import React, { SetStateAction, useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITradeAssetStats } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import { colors } from '../../const'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getTradeAssetBalanceToSwapFeesRatioConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_trade_asset_stats', timeframe)) as ITradeAssetStats[]
	const pools = ['BTC.BTC', 'ETH.ETH', 'BSC.BNB', 'LTC.LTC', 'BCH.BCH', 'GAIA.ATOM', 'AVAX.AVAX', 'DOGE.DOGE', 'STABLECOIN', 'BASE.ETH', 'XRP.XRP', 'TRON.TRX', 'ZEC.ZEC', 'Others']
	const assetData: ITradeAssetStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []
	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.ASSET_TYPE === pool))
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: ITradeAssetStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.TRADE_ASSET_TO_SWAP_FEES_RATIO }
			})
		)
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase() === 'STABLECOIN' ? 'STABLECOINS' : pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[ratio]',
			color: colors[i],
			unitSymbol: ' '
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TradeAssetBalanceToSwapFeesRatio = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTradeAssetBalanceToSwapFeesRatioConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Trade Asset Balance Value to Swap Fees Ratio"
			chartDesc={`Aggregated value of trade asset balances divided by swap fees.\n*STABLECOIN consists of all available stablecoin pools on THORChain.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="56b70e67-8ac9-4c9e-9569-852dfae88fbf"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default TradeAssetBalanceToSwapFeesRatio
